import api from 'services/api'
import {
  GET_SERVICE_CATEGORY_LIST,
  CREATE_SERVICE_CATEGORY,
  GET_SERVICE_CATEGORY_DETAIL,
  UPDATE_SERVICE_CATEGORY,
  DELETE_SERVICE_CATEGORY,
} from '../endpoints'

export const getServiceCategoryList = async (body) =>
  await api.post(GET_SERVICE_CATEGORY_LIST, body)
export const deleteServiceCategory = async (id) =>
  await api.delete(DELETE_SERVICE_CATEGORY, {data: {id: id}})
export const getServiceCategoryDetail = async (id) =>
  await api.get(`${GET_SERVICE_CATEGORY_DETAIL}?id=${id}`)

export const submitServiceCategory = async (values, id) =>
  await api.post(id ? UPDATE_SERVICE_CATEGORY : CREATE_SERVICE_CATEGORY, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
//   export const addServiceCategoryImage = async (id, values) =>
//     await api.post(`${ADD_AD_IMAGE}?ad_id=${id}`, values, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     })
